import React from 'react';
import {Form, Icon} from "antd";
import {Formik} from "formik";
import * as Yup from 'yup';
import {TextInput} from "../Boilerplate/formikComponents";
import {compose} from "redux";
import {connect} from "react-redux";
import {resetPassword} from "../../actions/users";
import logo from "../cProject-banner-new.png";
import {ResetPasswordButton} from "./Boilerplate/ResetPasswordButton";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sent: false,
    }
  }

  sendView = (props) => {
    return (
      <React.Fragment>
        <p>Enter your email address below and we'll email you a link to reset your password.
          Please be sure to also check your spam or junk mail for the link.</p>
        <TextInput
          {...props}
          key='username'
          name='username'
          placeholder='Email Address'
          inputProps={{ prefix: (<Icon type='user'/>), autoCorrect: 'off', autoCapitalize: 'none', }}
        />
      </React.Fragment>
    )
  };

  render() {
    const {
      onStateChange,
      onSubmit,
    } = this.props;
    const { sent } = this.state;

    return (
      <Formik
        initialValues={{ username: '' }}
        onSubmit={(values, { setSubmitting }) => {
          this.setState({ sent: true });
          const {username} = values;
          onSubmit && onSubmit(decodeURIComponent(username));
        }}
        validationSchema={Yup.object().shape({
          username: Yup.string()
            .email('Must be a valid email address')
            .required('Username cannot be blank'),
        })}
      >
        {props => {
          const {
            // eslint-disable-next-line
            values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
            handleSubmit,
          } = props;
          const { username } = values;
          return (
            <Form id='forgot-password' onSubmit={handleSubmit}>
              <img id='authlogo' src={logo} alt=''/>
              <h1>Reset your password</h1>
              {sent ?
                <p>Thank you. If you inputted an email address that matches an account in cProject, instructions will be
                  sent to {username} with information on what to do next. You should receive it
                  shortly.</p> : this.sendView(props)
              }
              <Form.Item>
                {sent || <ResetPasswordButton onClick={handleSubmit}/>}
                <a onClick={() => onStateChange('signedOut')}>{sent ? 'Back to ' : ''}Log In</a>
              </Form.Item>
            </Form>
          );
        }}
      </Formik>
    )
  }
}

export default compose(
  connect(
    null,
    (dispatch, props) => ({
      onSubmit: (username) => dispatch(resetPassword(username)),
    })
  )
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/Security/ForgotPassword.js